import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import { getValidationSchemaForIntros, initialValues, FORM_FIELDS } from './constants';
import { CustomTextArea } from 'components/CustomTextArea';
import { EWButton } from 'components/EWButton';
import { dialog } from '@microsoft/teams-js';

const IntroDetailsForm = ({ setSubmitLoader, isFavFoodEnabled, isLanguagesEnabled }) => {
    const handleSubmit = (values) => {
        let data = {
            designation: values.designation,
            aboutMe: values.aboutMe,
            favoriteFood: values?.favoriteFood,
            languages: values?.languages,
        };

        setSubmitLoader(true);
        dialog.url.submit(
            { data: data, startedVia: 'EW Shortcuts messaging extension', flagType: 'introform_submit' },
            [process.env.REACT_APP_TEAMS_APP_ID, process.env.REACT_APP_TEAMS_APP_ID_NEW]
        );
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={getValidationSchemaForIntros(isFavFoodEnabled, isLanguagesEnabled)}
            onSubmit={handleSubmit}
            enableReinitialize
        >
            <Form>
                <div className='intros-container'>
                    <CustomTextArea {...FORM_FIELDS.designation} height='36px' resize='none' />
                    <div className='about-me-container'>
                        <CustomTextArea {...FORM_FIELDS.aboutMe} height='124px' resize='none' />
                        <p className='max-chars-text'>Max 300 characters</p>
                    </div>
                    {isFavFoodEnabled && <CustomTextArea {...FORM_FIELDS.favoriteFood} height='36px' resize='none' />}
                    {isLanguagesEnabled && <CustomTextArea {...FORM_FIELDS.languages} height='36px' resize='none' />}
                    <EWButton appearance='primary' buttonText='Submit' />
                </div>
            </Form>
        </Formik>
    );
};

IntroDetailsForm.defaultProps = {
    isFavFoodEnabled: false,
    isLanguagesEnabled: false,
};

IntroDetailsForm.propTypes = {
    setSubmitLoader: PropTypes.func.isRequired,
    isFavFoodEnabled: PropTypes.bool,
    isLanguagesEnabled: PropTypes.bool,
};

export default IntroDetailsForm;
